import React, { useState } from "react";
import { Card, CardMedia, CardContent, Typography, Grid } from "@mui/material";
import Sunlight from "./Icons/Sunlight";

const PlantCard = ({ plant, ...props }) => {
  const [isFlower, setIsFlower] = useState(false);

  const handleImageClick = () => {
    setIsFlower(!isFlower);
  };

  // if plant.sunlight is not an array make it one
  if (!Array.isArray(plant.sunlight)) {
    plant.sunlight = [plant.sunlight];
  }
  // if flowering time is not an array make it one
  if (!Array.isArray(plant.floweringTime)) {
    plant.floweringTime = [plant.floweringTime];
  }

  // if the plant only has a name then show a simple card
  if (!plant.plantImage && !plant.flowerImage) {
    return (
      <Card {...props}>
        <CardContent>
          <Typography variant="h5" component="div">
            {plant.name}
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card {...props}>
      <CardMedia
        component="img"
        height="200"
        image={isFlower ? plant.flowerImage : plant.plantImage}
        alt={plant.name}
        onClick={handleImageClick}
      />
      <CardContent>
        <Typography variant="h5" component="div">
          {plant.name}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body1" color="text.secondary">
              Type: {plant.category}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Size: {plant.height}m x {plant.width}m
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Sunlight value={plant.sunlight} />
            <Typography variant="body1" color="text.secondary">
              FlTime: {plant.floweringTime}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PlantCard;
